const getState = () => {
  return {
    user: {},
    auth: {},
    currentRoute: [],
    servicename: "",
  };
};
const state = getState();
const mutations = {
  SET_AUTH: (state, auth) => {
    state.auth = auth;
    let arr = [];
    let arr1 = [];
    if (state.auth === undefined || state.auth.routes === undefined || state.auth.routes === null) {
      if (state.auth === undefined) {
        state.auth = {};
      }
      state.auth.routes = [];
    }
    state.auth.routes.forEach((item1) => {
      item1.node.forEach((item2) => {
        arr1.push(item2.resCode);
        item2.node.forEach((item3) => {
          arr1.push(item3.resCode);
          arr.push(...item3.button);
        });
      });
    });
    state.auth.routeAuth = arr1; //路由权限列表
    state.auth.buttonAuth = arr; //元素权限列表
  },
  RESET_STATE: (state) => {
    Object.assign(state, getState());
  },
  SET_USER: (state, user) => {
    state.user = user;
  },
  SET_CURRENTROUTE: (state, obj) => {
    state.currentRoute = []
    state.auth.routes.forEach((item) => {
      if (!obj.flag) {
        if (obj.path) {//用路径判断
          if (item.homePage.split('/')[1].toLowerCase() == obj.name.toLowerCase()) {
            state.currentRoute = item || [];
          }
        } else if (item.resCode == obj.name) {
          state.currentRoute = item || [];
        }
      } else {
        item.node.forEach(item2 => {
          if (item2.resCode == obj.name) {
            state.currentRoute = item || [];
          }
        })
      }
    });
  },
  CHANGE_ROUTE: (state, to) => {
    //设置当前服务名称
    if (
      to.name !== "login" &&
      to.name !== "main" &&
      to.name !== "noRight" &&
      to.name !== "notFound"
    ) {
      let firstUrl1 = to.path.split("/")[1];
      // console.log(2222,state)
      state.auth.routes.forEach((item) => {
        let firstUrl2 = item.homePage.split("/")[1];
        if (firstUrl1 == firstUrl2) {
          state.servicename = item.systemType;
        }
      });
    } else {
      state.servicename = "ape-identity-server";
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
